"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const highContrast = {
  whiteOnBlack: {
    '@media (forced-colors: active) and (prefers-color-scheme: dark)': {
      filter: 'invert(100%)'
    }
  },
  blackOnWhite: {
    '@media (forced-colors: active) and (prefers-color-scheme: light)': {
      filter: 'invert(100%)'
    }
  },
  prefersDark: '@media (forced-colors: active) and (prefers-color-scheme: dark)',
  prefersLight: '@media (forced-colors: active) and (prefers-color-scheme: light)',
  mediaQuery: key => `@media (forced-colors: ${key})`
};
const reduceMotion = {
  mediaQuery: () => `@media (prefers-reduced-motion)`
};
var _default = exports.default = {
  highContrast,
  reduceMotion
};